import { render, staticRenderFns } from "./faq-theme.vue?vue&type=template&id=d57c6512&scoped=true"
import script from "./faq-theme.vue?vue&type=script&lang=js"
export * from "./faq-theme.vue?vue&type=script&lang=js"
import style0 from "./faq-theme.vue?vue&type=style&index=0&id=d57c6512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57c6512",
  null
  
)

export default component.exports